import React, { Component } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardContent, IonItem, IonLabel, IonInput, IonButton, IonText, withIonLifeCycle } from '@ionic/react'
import userService from '../../resources/Authentication/userServices'
import { menuController } from '@ionic/core'


export class Login extends Component {
    state = {
        userName: '',
        password: '',
        sumbitted: false,
        loading: false,
        error: ''
    }

    clearAll = () => {
        this.setState({
            userName: '',
            password: '',
            sumbitted: false,
            loading: false,
            error: ''
        })
    }


    onSubmit = (e) => {
        e.preventDefault()
        console.log(this.state);
        this.setState({
            sumbitted: true,
        })
        const { userName, password } = this.state;

        this.setState({ loading: true });

        userService.login(userName, password).then(() => {
            this.props.history.push('/');
            
            // window.location.href = '/';
        },
            error => this.setState({
                error,
                loading: false,
            })
        )

    }

    /**On UI Fields Change */
    onChange = (e) => {
        
        this.setState({
            [e.target.id]: e.target.value,
        })
    }


    ionViewDidEnter() {
        menuController.enable(false, 'mainmenu')
    }
    ionViewWillLeave() {
        menuController.enable(true, 'mainmenu');
        this.clearAll()
    }

    render() {
        // console.log(this.props);
        
        const { loading, error } = this.state;
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Login</IonTitle>
                    </IonToolbar>
                </IonHeader>

                <IonContent>
                    <IonGrid>
                        <IonRow class='ion-justify-content-center'>
                            <IonCol class='ion-align-self-center' sizeMd='6' sizeLg='5' sizeXs='12'>
                                <IonCard>
                                    <IonCardHeader>
                                        <IonTitle>
                                            User Login Details
                                        </IonTitle>
                                    </IonCardHeader>
                                    <IonCardContent>
                                        <form onSubmit={this.onSubmit}>
                                            <IonItem>
                                                <IonLabel position='stacked'>Username</IonLabel>
                                                <IonInput required='true' type='text' id='userName' onIonInput={this.onChange}></IonInput>
                                            </IonItem>
                                            <IonItem>
                                                <IonLabel position='stacked'>Password</IonLabel>
                                                <IonInput required='true' type='password' id='password' onIonInput={this.onChange}></IonInput>
                                            </IonItem>

                                            <div className="ion-padding">
                                                <IonButton type='submit' size='default' disabled={loading} expand='block'>
                                                    <IonInput type='submit'>Login</IonInput>
                                                    </IonButton>
                                            </div>

                                            {error && <IonText class='red-text'>{error}</IonText> }

                                        </form>

                                    </IonCardContent>
                                </IonCard>
                            </IonCol>

                        </IonRow>
                    </IonGrid>
                </IonContent>
            </IonPage>
        )
    }
}

export default withIonLifeCycle(Login)

